module.exports = __webpack_public_path__ + "img/accueil-mariage.54179ddf.jpg";